import numeral from 'numeral'

if (!Object.keys(numeral.locales).includes('en')) {
  numeral.register('locale', 'en', {
    delimiters: {
      thousands: ',',
      decimal: '.'
    },
    abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: number => (number === 1 ? 'st' : 'rd'),
    currency: {
      symbol: '$',
      format: '$0,0.00'
    }
  })
}

if (!Object.keys(numeral.locales).includes('es')) {
  numeral.register('locale', 'es', {
    delimiters: {
      thousands: '.',
      decimal: ','
    },
    abbreviations: {
      thousand: 'm',
      million: 'M',
      billion: 'b',
      trillion: 't'
    },
    ordinal: () => 'º',
    currency: {
      symbol: '€',
      format: '0,0.00 $'
    }
  })
}

numeral.locale('en')

numeral.getCurrencyFormat = function getCurrencyFormat() {
  const localeData = this.localeData()
  return localeData && localeData.currency && localeData.currency.format
}
numeral.getCurrencySymbol = function getCurrencySymbol() {
  const localeData = this.localeData()
  return localeData && localeData.currency && localeData.currency.symbol
}

export default numeral



// WEBPACK FOOTER //
// ./src/core/numeral.js